import { render, staticRenderFns } from "./CommunicationHistoryView.vue?vue&type=template&id=1d4ce812&scoped=true"
import script from "./CommunicationHistoryView.vue?vue&type=script&lang=js"
export * from "./CommunicationHistoryView.vue?vue&type=script&lang=js"
import style0 from "./CommunicationHistoryView.vue?vue&type=style&index=0&id=1d4ce812&prod&lang=scss&scoped=true"
import style1 from "./CommunicationHistoryView.vue?vue&type=style&index=1&id=1d4ce812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ce812",
  null
  
)

export default component.exports